<div
  class="banner-background row px-5 py-2 mx-0"
  [style.background]="'url(' + backgroundImageUrl + ')'"
  [style.background-repeat]="'no-repeat'"
  [style.background-size]="'cover'"
  [style.background-position]="'top'"
>
  <img class="top-center-logo" [src]="logoUrl" />
  <div class="header-icons-list text-white">
    <div class="pt-1 d-flex justify-content-center">
      <span class="text-size-32 mt-1 d-flex text-center main-title">
        {{ title }}
      </span>
    </div>
    <div class="pt-2 text-center subtitle">
      <span class="text-size-18 font-weight-light w-100">
        {{ subTitle }}
      </span>
    </div>
    <div class="p-4 text-center">
      <app-floating-button
        link="https://www.sportys.com/sportys-pilot-training-plus.html?utm_source=onlinecoursedemo&utm_medium=referral&utm_content=PTPportalbutton"
        label="Gain Access Now"
      />
    </div>
    <div class="d-md-flex d-none text-white justify-content-between header-icons-wrapper">
      <hr class="col-12 my-2 d-md-block d-none color-white mt-1 pt-1 header-divider" />
      <div class="d-flex justify-content-between w-100">
        <app-banner-icon
          *ngFor="let icon of icons"
          [backgroundImageUrl]="icon.iconPath"
          [title]="icon.title"
          [bigTitle]="true"
          [description]="icon.description"
          [color]="'gray'"
        />
      </div>
    </div>
  </div>
</div>
